export default __webpack_public_path__ + "static/media/time.8b1ae088.svg";